const ResearchPublications = ({ data }) => {
  const { main_title, main_icon, content_blocks } = data;
  const webUrl = process.env.REACT_APP_WEB_URL;

  return (
    <section className="dp-research-section py-5">
      <div className="container">

        {/* Animate ONLY heading */}
        <div
          className="row"
          data-sal="slide-up"
          data-sal-duration="300"
          data-sal-once="true"
        >
          <div className="col-12 py-lg-3 dp-heading-icon-wrapper">
            {main_icon && (
              <img
                src={`${webUrl}${main_icon}`}
                alt="heading-icon"
                className="dp-heading-icon"
              />
            )}
            <h2 className="section-title text-capitalize">
              {main_title}
            </h2>
          </div>
        </div>

        {/* Content loads instantly */}
        <div className="row mt-5">
          {content_blocks?.map((block, blockIndex) => (
            <div key={blockIndex} className="col-12 mb-5">
              {block.title && (
                <p className="theme-section-title">{block.title}</p>
              )}

              <ul className="dp-points-list">
                {block.items?.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    {item.title && (
                      <span className="dp-strong">{item.title} </span>
                    )}
                    {item.desc}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ResearchPublications;
